import {get} from 'lodash';

export default (state = {}, {coachId, stateName, stateValue}: any) => {
  return {
    ...state,
    allNotesState: {
      ...get(state, 'allNotesState', {}),
      [coachId]: {
        ...get(state, `allNotesState.${coachId}`, {}),
        [stateName]: stateValue,
      },
    },
  };
};
